"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var provider_1 = require("../../../theme/provider");
var chroma_js_1 = __importDefault(require("chroma-js"));
var Spin_1 = __importDefault(require("../Spin/Spin"));
var utils_1 = require("../../../utils/utils");
var ModeTypes = {
    PRIMARY: "primary",
    SECONDARY: "secondary",
    OUTLINE: "outline",
    WHITE: "white",
    ICON: "icon",
    SECONDARY_OUTLINE: "secondary outline",
    GRAY: "gray",
};
var StyledButton = (0, styled_components_1.default)("button")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-weight: bold;\n  font-size: ", ";\n  line-height: ", ";\n  cursor: pointer;\n  padding: ", ";\n  border-radius: ", "px;\n  -webkit-font-smoothing: antialiased;\n  box-sizing: border-box;\n  border-style: solid;\n  border-width: 2px;\n  border-color: ", ";\n  transition: box-shadow 0.2s ease-in-out, border 0.2s ease-in,\n    background 0.2s ease-in, color 0.2s ease-in, opacity 0.2s ease-in;\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  flex-shrink: 0;\n\n  ", "\n\n  pointer-events: ", ";\n\n  & > svg {\n    margin: ", ";\n    height: ", ";\n    width: ", ";\n  }\n\n  &:focus,\n  &:active {\n    border-style: solid;\n    border-width: 2px;\n    border-color: ", ";\n  }\n\n  &:hover {\n    color: ", ";\n    border: ", ";\n\n    ", ";\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    border-color: transparent;\n    background-color: ", ";\n    ", ";\n  }\n\n  &.dropdown {\n    all: unset;\n    font-family: ", ";\n    transition: background 0.2s ease-in, color 0.2s ease-in;\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    padding: 11px 13px;\n    font-size: 13px;\n    .profileIcon {\n      width: 30px;\n      height: 30px;\n    }\n    &:hover {\n      background-color: #f8f8f8;\n    }\n  }\n\n  /* &:focus,\n  &:active {\n    ", "\n    color: ", "\n  } */\n"], ["\n  background: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-weight: bold;\n  font-size: ", ";\n  line-height: ", ";\n  cursor: pointer;\n  padding: ", ";\n  border-radius: ", "px;\n  -webkit-font-smoothing: antialiased;\n  box-sizing: border-box;\n  border-style: solid;\n  border-width: 2px;\n  border-color: ", ";\n  transition: box-shadow 0.2s ease-in-out, border 0.2s ease-in,\n    background 0.2s ease-in, color 0.2s ease-in, opacity 0.2s ease-in;\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  flex-shrink: 0;\n\n  ", "\n\n  pointer-events: ", ";\n\n  & > svg {\n    margin: ", ";\n    height: ", ";\n    width: ", ";\n  }\n\n  &:focus,\n  &:active {\n    border-style: solid;\n    border-width: 2px;\n    border-color: ", ";\n  }\n\n  &:hover {\n    color: ", ";\n    border: ", ";\n\n    ", ";\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    border-color: transparent;\n    background-color: ", ";\n    ", ";\n  }\n\n  &.dropdown {\n    all: unset;\n    font-family: ", ";\n    transition: background 0.2s ease-in, color 0.2s ease-in;\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    padding: 11px 13px;\n    font-size: 13px;\n    .profileIcon {\n      width: 30px;\n      height: 30px;\n    }\n    &:hover {\n      background-color: #f8f8f8;\n    }\n  }\n\n  /* &:focus,\n  &:active {\n    ", "\n    color: ", "\n  } */\n"])), function (_a) {
    var mode = _a.mode, theme = _a.theme, invert = _a.invert;
    if (mode && mode.includes(ModeTypes.OUTLINE)) {
        return "transparent";
    }
    if (invert) {
        return theme.invertColor;
    }
    if (mode === ModeTypes.WHITE) {
        return theme.white;
    }
    if (mode === ModeTypes.ICON) {
        return "transparent";
    }
    if (mode === ModeTypes.GRAY) {
        return theme.gray2;
    }
    return (theme === null || theme === void 0 ? void 0 : theme.primaryColor) || "black";
}, function (_a) {
    var theme = _a.theme, mode = _a.mode, invert = _a.invert;
    if ((mode && mode.includes(ModeTypes.OUTLINE)) || mode === "icon") {
        if (invert) {
            return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.dm__outlineButtonInvertColor, theme.outlineButtonInvertColor, theme.textColor);
        }
        return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.dm__outlineButtonColor, theme.textColor, theme.textColor);
    }
    if (mode === ModeTypes.WHITE) {
        return theme.black;
    }
    return theme.white;
}, function (props) { return (0, provider_1.getFontFromTheme)(props.theme).fontFamily; }, function (props) {
    if (props.mode) {
        switch (props.mode) {
            case ModeTypes.PRIMARY:
            case ModeTypes.SECONDARY:
            case ModeTypes.OUTLINE:
            case ModeTypes.SECONDARY_OUTLINE:
            case ModeTypes.ICON:
            case ModeTypes.GRAY:
                return "16px";
            case ModeTypes.WHITE:
            default:
                return "14px";
        }
    }
    return "18px";
}, function (props) {
    if (props.mode === ModeTypes.ICON) {
        return "1.5";
    }
    return "1.55em";
}, function (props) {
    if (props.mode === ModeTypes.ICON) {
        return "8px 16px";
    }
    else if (props.mode === ModeTypes.SECONDARY ||
        props.mode === ModeTypes.SECONDARY_OUTLINE) {
        return "4px 13px";
    }
    return "8px 16px";
}, function (props) { var _a; return ((_a = props.theme) === null || _a === void 0 ? void 0 : _a.buttonRadius) || 2; }, function (_a) {
    var theme = _a.theme, mode = _a.mode, invert = _a.invert;
    if (mode === null || mode === void 0 ? void 0 : mode.includes(ModeTypes.OUTLINE)) {
        if (invert) {
            return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.dm__outlineButtonInvertColor, theme.outlineButtonInvertColor, theme.primaryColor);
        }
        return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.dm__outlineButtonColor, theme.outlineButtonColor, theme.primaryColor);
    }
    return "transparent";
}, function (props) { return (props.block ? "width:100%;" : ""); }, function (props) {
    if (props.loading) {
        return "none";
    }
    return "auto";
}, function (props) {
    if (props.mode === ModeTypes.ICON) {
        return "0";
    }
    return "0 9px";
}, function (props) {
    if (props.mode) {
        switch (props.mode) {
            case ModeTypes.PRIMARY:
            case ModeTypes.SECONDARY:
            case ModeTypes.OUTLINE:
            case ModeTypes.SECONDARY_OUTLINE:
                return "18px";
            default:
                return "14px";
        }
    }
    return "18px";
}, function (props) {
    if (props.mode === ModeTypes.ICON) {
        return "14px";
    }
    return "18px";
}, function (props) {
    if (props.invert && props.mode !== ModeTypes.OUTLINE) {
        return props.theme.gray1;
    }
    else if (props.mode === ModeTypes.ICON) {
        return "transparent";
    }
    return props.theme.white;
}, function (props) {
    if (props.mode !== ModeTypes.ICON) {
        return props.theme.primaryColor;
    }
}, function (props) {
    if (props.mode && props.mode.includes(ModeTypes.OUTLINE)) {
        return "2px solid ".concat((0, chroma_js_1.default)(props.theme.primaryColor).alpha(0.4).hex());
    }
}, function (props) {
    if (props.theme) {
        if (props.invert) {
            if (props.mode && props.mode.includes(ModeTypes.OUTLINE)) {
                return "\n              background: ".concat(props.theme.white, ";\n              color: ").concat(props.theme.gray1, ";\n            ");
            }
            return "\n            background: ".concat((0, chroma_js_1.default)(props.theme.invertColor).alpha(0.3).hex(), ";\n            color: ").concat(props.theme.invertColor, ";\n            text-decoration:none;\n          ");
        }
        else if (props.mode === ModeTypes.WHITE) {
            return "\n            background: ".concat((0, chroma_js_1.default)(props.theme.white).alpha(0.85).hex(), ";\n            color: ").concat(props.theme.gray1, ";\n          ");
        }
        else if (props.mode === ModeTypes.ICON) {
            return "\n            background: ".concat(props.theme.gray3, ";\n            ");
        }
        else {
            if (props.mode && props.mode.includes(ModeTypes.OUTLINE)) {
                return "\n              background: ".concat((0, utils_1.getStylesBasedOnTheme)(props.theme.mode, props.theme.white, "transparent"), ";\n              color: ").concat((0, utils_1.getStylesBasedOnTheme)(props.theme.mode, props.theme.black, props.theme.textColor), ";\n            ");
            }
            if (props.mode && props.mode === ModeTypes.GRAY) {
                return "\n              color: ".concat((0, chroma_js_1.default)(props.theme.white).alpha(0.85).hex(), ";\n              background: ").concat((0, chroma_js_1.default)(props.theme.gray2).alpha(0.85).hex(), ";\n            ");
            }
            return "\n            color: ".concat((0, chroma_js_1.default)(props.theme.white).alpha(0.85).hex(), ";\n            background: ").concat((0, chroma_js_1.default)(props.theme.primaryColor).alpha(0.85).hex(), ";\n          ");
        }
    }
}, function (_a) {
    var theme = _a.theme;
    if (theme) {
        return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.dm__primaryButtonDisabled, theme.primaryButtonDisabled, "rgba(".concat((0, chroma_js_1.default)(theme.gray1).rgb().join(","), ", 0.2)"));
    }
}, function (props) {
    if (props.invert) {
        return "color: ".concat(props.theme.white, ";");
    }
    if (props.mode && props.mode.includes(ModeTypes.OUTLINE)) {
        return "color: ".concat(props.theme.textColor, ";\n        background: ").concat(props.theme.white, ";\n        border: 1px solid ").concat(props.theme.primaryButtonDisabled, ";\n        ");
    }
}, function (props) { return (0, provider_1.getFontFromTheme)(props.theme).fontFamily; }, function (props) {
    if (props.theme) {
        return "background: rgba(".concat((0, chroma_js_1.default)(props.theme.gray1)
            .rgb()
            .join(","), ", 0.2);");
    }
}, function (props) { return props.theme.white; });
// Main button with styles
var Button = function (_a) {
    var as = _a.as, children = _a.children, _b = _a.mode, mode = _b === void 0 ? ModeTypes.PRIMARY : _b, invert = _a.invert, _c = _a.loading, loading = _c === void 0 ? false : _c, _d = _a.block, block = _d === void 0 ? false : _d, _e = _a.className, className = _e === void 0 ? "" : _e, props = __rest(_a, ["as", "children", "mode", "invert", "loading", "block", "className"]);
    var theme = React.useContext(styled_components_1.ThemeContext);
    var loadingColor = React.useMemo(function () {
        if (mode === ModeTypes.OUTLINE) {
            if (invert) {
                return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.dm__outlineButtonInvertColor, theme.outlineButtonInvertColor, theme.primaryColor);
            }
            return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.dm__outlineButtonColor, theme.outlineButtonColor, theme.primaryColor);
        }
        return theme.white || "#fff";
    }, [mode, theme]);
    return ((0, jsx_runtime_1.jsxs)(StyledButton, __assign({ invert: invert, as: as !== null && as !== void 0 ? as : "button", mode: mode, loading: loading, block: block }, props, { className: "wellms-component ".concat(className), role: "button", "aria-labelledby": "labeldiv" }, { children: [loading && (0, jsx_runtime_1.jsx)(Spin_1.default, { color: loadingColor }), children] })));
};
exports.Button = Button;
exports.default = (0, styled_components_1.withTheme)((0, styled_components_1.default)(exports.Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""]))));
var templateObject_1, templateObject_2;
